import { render } from "./NavbarComponent.vue?vue&type=template&id=32674a33&scoped=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts"

import "./NavbarComponent.vue?vue&type=style&index=0&id=32674a33&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32674a33"

export default script